import request from "@/utils/request"

// 角色列表
export function RoleList(pageIndex, pageSize, roleName) {
  return request({
    url: "/admin/system/role/findPage",
    method: "POST",
    data: {
      pageNum: pageIndex + 1,
      pageSize,
      columnFilters: roleName ? {
        roleName: {
          name: 'roleName',
          value: roleName
        }
      } : {}
    }
  })
};

// 角色列表
export function RoleAll() {
  return request({
    url: "/admin/system/role/findAll",
    method: "GET",
  })
};

// 创建角色
export function CreateRole(name, remark) {
  return request({
    url: "/admin/system/role/save",
    method: "POST",
    data: {
      name,
      remark
    }
  })
};

// 删除角色
export function DelRole(id) {
  return request({
    url: `/admin/system/role/delete`,
    method: "POST",
    data: {
      id
    }
  })
};

//查看角色信息
export function RoleInfo(id) {
  return request({
    url: `/admin/system/role/findById`,
    method: "POST",
    data: {
      id
    }
  })
};

//查看角色当前菜单
export function getRoleMenus(roleId) {
  return request({
    url: `/admin/system/role/findRoleMenus?roleId=` + roleId,
    method: "GET",
  })
};

// 修改角色信息
export function upDataRoleInfo(id, name, remark) {
  return request({
    url: `/admin/system/role/save`,
    method: "POST",
    data: {
      id,
      name,
      remark,
    }
  })
}
// 保存角色当前菜单
export function saveRoleMenus(roleId, menuIds) {
  return request({
    url: `/admin/system/role/saveRoleMenus`,
    method: "POST",
    data: {
      roleId,
      menuIds,
    }
  })
}

// 查询角色下用户
export function getRoleUsers(roleId) {
  return request({
    url: `/admin/system/role/findRoleUsers?roleId=` + roleId,
    method: "GET",
  })
}

// 角色增加用户
export function addRoleUsers(roleId, userIds) {
  return request({
    url: `/admin/system/role/addRoleUsers`,
    method: "POST",
    data: {
      roleId,
      userIds,
    }
  })
}

// 角色移除用户
export function removeRoleUser(roleId, userId) {
  return request({
    url: `/admin/system/role/removeRoleUser`,
    method: "POST",
    data: {
      roleId,
      userId,
    }
  })
}
